var LibrariesList = function() {

	var comp = $('[data-component="libraries-list"]'), filter = $('[data-component="libraries-filter"]'), itens = $('[data-component="library-item"]');

	this.init = function() {

		check();

		filterList();

	}

	function check() {

		itens.each(function() {
			if($(this).data('category') === filter.find('.active').data('id')) {
				$(this).fadeIn(300);
			}
		});

	}

	function filterList() {

		filter.find('a').on('click', function(e) {
			e.preventDefault();
			if(!$(this).hasClass('active')) {
				filter.find('a').removeClass('active');
				$(this).addClass('active');
				itens.fadeOut(300);
				setTimeout(function() {
					check();
				}, 305);
			}
		});

	}

	return this.init();

}
